import { Button } from '@mui/material';
import React from 'react';

function FlatButton({ label, primary, ...props }) {
  return (
    <Button variant="text" color={primary ? 'primary' : 'default'} {...props}>
      {label}
    </Button>
  );
}

export default FlatButton;
